

import { ReportByStatus } from '../../../../../common/types/interfaces'
import { getOrderStatusColor, getOrderStatusText } from '../../../../../common/utils/functions/enumToText'
import classes from './ByStatus.module.sass'

type Props = {
  rows: ReportByStatus[]
}

const PLACEHOLDER_ROWS = 7

export const ByStatus = ({ rows }: Props) => {
  return (
    <div className={classes.table}>
      <div className={classes.header}>
        <span>Статус</span>
        <span>Кол-во</span>
        <span>Сумма</span>
      </div>
      {rows.length === 0
        ? Array.from({ length: PLACEHOLDER_ROWS }).map((_, i) => (
            <div key={i} className={classes.row}>
              <span>—</span>
              <span>—</span>
              <span>—</span>
            </div>
          ))
        : rows.map((r) => (
            <div key={r.status} className={classes.row}>
              <span className={classes.status}>
                <span
                  className={classes.dot}
                  style={{ backgroundColor: getOrderStatusColor(r.status) }}
                />
                {getOrderStatusText(r.status)}
              </span>
              <span>{r.count}</span>
              <span>{r.sum} ₽</span>
            </div>
          ))}
    </div>
  )
}
